import { z } from "zod";

import { toHumanErrorMessage } from "@/lib/extensions/httpErrorExtension";

type NotifyFn =
  | ((params: { type: "error"; message: string; description?: string }) => void)
  | undefined;

export function notifyMutationError(
  open: NotifyFn,
  action: string,
  error: unknown,
) {
  open?.({
    type: "error",
    message:
      error instanceof z.ZodError
        ? `${action} failed due to step validation`
        : `${action} failed`,
    description: toHumanErrorMessage(error),
  });
}
